import type { ReactNode } from "react";

import { BrandMark } from "@/components/layout/BrandMark";

type AuthSplitLayoutProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export function AuthSplitLayout({ title, description, children }: AuthSplitLayoutProps) {
  return (
    <div className="relative flex min-h-screen">
      <div className="relative hidden overflow-hidden bg-brand-gradient lg:flex lg:w-3/5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(255,255,255,0.22),transparent_45%)]" />
        <div className="relative flex h-full w-full flex-col justify-between p-10 text-white xl:p-14">
          <BrandMark withWordmark inverted />
          <div>
            <p className="font-display text-4xl font-semibold leading-tight xl:text-5xl">
              Source leads.
              <br />
              Track every application.
            </p>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/80">
              Secure access for DSAs and intermediaries. Create merchant applications and upload
              onboarding documents — Fincobox handles underwriting.
            </p>
          </div>
          <p className="text-xs text-white/55">© {new Date().getFullYear()} Fincobox</p>
        </div>
      </div>

      <div className="flex w-full items-center justify-center px-4 py-12 lg:w-2/5">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <BrandMark withWordmark />
          </div>
          <h1 className="font-display text-3xl font-semibold text-ink">{title}</h1>
          <p className="mt-2 text-sm text-muted">{description}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
